var $containerTabs = $("div#more");
var $tablistGroup = $containerTabs.find(".js-tabs");
var $tabcontentGroup = $containerTabs.find(".js-tab-content");

$tablistGroup.find("ul").each(function (indexTabList, tablist) {
  // Default behaviour - show content of 'active' tab
  var activeTabPaneID = $(tablist)
    .find("li.active a")
    .attr("href")
    .split("#")[1];
  $tabcontentGroup.find(".js-tab-pane").hide();
  $tabcontentGroup.find("#" + activeTabPaneID).show();
  var elem;

  if (isInTestingCentre()) {
    elem = "a";
  } else {
    elem = "button";
  }

  // 'Click' Event Listener injection
  $(tablist)
    .find("li")
    .each(function (indexTab, tab) {
      $(tab)
        .find(elem)
        .on("click", function (e) {
          e.preventDefault();

          // de-activate the current ACTIVE tab & its corresponding content
          $(tablist).find("li.active").removeClass("active");
          $tabcontentGroup.find("#" + activeTabPaneID).hide();

          // Activate THIS tab & its corresponding content
          $(tab).addClass("active");
          activeTabPaneID = $(tab).find("a").attr("href").split("#")[1];
          $tabcontentGroup.find("#" + activeTabPaneID).show();
        });
    });
});

function isInTestingCentre() {
  return $("#testing-centre").length > 0;
}
